import { Controller, useFormContext } from "react-hook-form";
import { MenuItem, TextField } from "@mui/material";

import SysColumn from "app/class/sys-column";
import { useTranslation } from "react-i18next";
import { translateMetadataLabel } from "modules/record/shared/services/recordMetadataLabels";

interface BooleanConditionValueFieldProps {
    column: SysColumn;
}

const BooleanConditionValueField = ({
    column,
}: BooleanConditionValueFieldProps) => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    return (
        <Controller
            name="value"
            control={control}
            render={({ field }) => (
                <TextField
                    select
                    size="small"
                    fullWidth
                    value={
                        field.value === true
                            ? "true"
                            : field.value === false
                                ? "false"
                                : ""
                    }
                    onChange={(event) => {
                        const nextValue = event.target.value;

                        if (nextValue === "") {
                            field.onChange(undefined);
                            return;
                        }

                        field.onChange(nextValue === "true");
                    }}
                    inputProps={{
                        "aria-label": `${translateMetadataLabel(t, column)} boolean value`,
                    }}
                >
                    <MenuItem value="">{t("Select...")}</MenuItem>
                    <MenuItem value="true">{t("True")}</MenuItem>
                    <MenuItem value="false">{t("False")}</MenuItem>
                </TextField>
            )}
        />
    );
};

export default BooleanConditionValueField;
